import { useState } from 'react';
import cn from 'classnames';
import BasicInput from './BasicInput';
import visibleIcon from '../assets/visible.svg';
import invisibleIcon from '../assets/invisible.svg';

const PasswordInput = ({ 
  className, 
  error,
  showRequirements = false,
  children,
  containerClassName,
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={cn("flex flex-col gap-1", containerClassName)}>
      <BasicInput
        type={showPassword ? "text" : "password"}
        inputClassName={cn("pr-10", {
          "border-[#ff5501]": error
        }, className)}
        error={error}
        containerClassName={containerClassName}
        {...props}
      >
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-[50%] -translate-y-[50%] h-[18px] flex items-center"
        >
          <img 
            src={showPassword ? visibleIcon : invisibleIcon} 
            alt="toggle password visibility" 
            className="w-[18px] h-[18px]" 
          />
        </button>
      </BasicInput>
      {children}
    </div>
  );
};

export default PasswordInput; 